import httpClient from 'client/js/models/http-client'

class CoursePlanStore {
   static async load(id) {
      try {
         let response = await httpClient.get(BaseURL + `/api/course-plan-store/${id}`)
         return response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response) {
            console.log('Course Plan Load Error', response.data.response)
            err = new Error('Course Plan Load Error')
            // Keep response data as error properties
            Object.assign(err, response.data)
         }
         throw (err)
      };
   }
   static async save(plan) {
      let id = null
      try {
         const response = await httpClient.post(BaseURL + "/api/course-plan-store/", { plan })
         id = response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response) {
            console.log('Save Plan Error', response.data.response)
            err = new Error('Save Plan Error')
            // Keep response data as error properties
            Object.assign(err, response.data)
         }
         throw (err)
      }
      if (id == null) {
         const message = 'Save Plan Error - id value not returned'
         console.log(message, response.data.response)
         throw message
      }
      return id
   }

   static async validate(plan) {
      let validationErrors = null
      try {
         const response = await httpClient.post(BaseURL + "/api/course-plan-store/validate/", { plan })
         validationErrors = response.data
      } catch (err) {
         let response = err.response
         if (response && response.data.response) {
            console.log('Save Plan Error', response.data.response)
            err = new Error('Save Plan Error')
            // Keep response data as error properties
            Object.assign(err, response.data)
         }
         throw (err)
      }
      if (validationErrors == null) {
         const message = 'Validate Plan Error - value not returned'
         console.log(message, response.data.response)
         throw message
      }
      return validationErrors
   }
}

module.exports = CoursePlanStore
